const AUTHORIZATION_TOKEN_KEY = `${process.env.REACT_APP_STORAGE_NAMESPACE}_auth.authorizationToken`;
const REFRESH_TOKEN_KEY = `${process.env.REACT_APP_STORAGE_NAMESPACE}_auth.refreshToken`;
const ID_TOKEN_KEY = `${process.env.REACT_APP_STORAGE_NAMESPACE}_auth.identityToken`;

const clear = () => {
  localStorage.removeItem(AUTHORIZATION_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ID_TOKEN_KEY);
};

const getAuthorizationToken = (): string | null => {
  return localStorage.getItem(AUTHORIZATION_TOKEN_KEY);
};

const setAuthorizationToken = (token: string) => {
  localStorage.setItem(AUTHORIZATION_TOKEN_KEY, token);
};

const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

const setRefreshToken = (token: string) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

const getIdentityToken = (): string | null => {
  return localStorage.getItem(ID_TOKEN_KEY);
};

const setIdentityToken = (token: string) => {
  localStorage.setItem(ID_TOKEN_KEY, token);
};

const AuthTokenStorage = {
  getAuthorizationToken,
  setAuthorizationToken,
  getRefreshToken,
  setRefreshToken,
  getIdentityToken,
  setIdentityToken,
  clear,
};

export default AuthTokenStorage;
